/* eslint-disable no-nested-ternary */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@type/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.about || initialState;

export const selectIsLoading = createSelector(
  [selectDomain],
  state => state.loading,
);

export const selectIsError = createSelector(
  [selectDomain],
  state => state.error,
);

export const selectIsSuccess = createSelector(
  [selectDomain],
  state => state.success,
);

export const selectAboutPage = createSelector(
  [selectDomain],
  state => state.about || undefined,
);
